import { render, staticRenderFns } from "./CeldaActivoInactivo.vue?vue&type=template&id=44410c1b&scoped=true"
import script from "./CeldaActivoInactivo.vue?vue&type=script&lang=js"
export * from "./CeldaActivoInactivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44410c1b",
  null
  
)

export default component.exports